import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, sessionStore } from '@/lib/api';

// Same shape as AppleCallback: the Google Identity Services library returns
// an id_token via the credential field of the response. We exchange + redirect.

export function GoogleCallback() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Verifying with Google…');

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.slice(1));
    const idToken = params.get('id_token') ?? params.get('credential');
    if (!idToken) {
      setStatus('No id_token returned by Google.');
      return;
    }
    api
      .oauthGoogle({ id_token: idToken })
      .then((pair) => {
        sessionStore.set(pair.access, pair.refresh, pair.user);
        navigate(pair.user.profile_complete ? '/home' : '/auth/profile');
      })
      .catch((err) => setStatus(err.message ?? 'Sign-in failed.'));
  }, [navigate]);

  return (
    <main style={{ maxWidth: 440, margin: '0 auto', padding: '120px 24px', textAlign: 'center' }}>
      <p>{status}</p>
    </main>
  );
}
